import api from '../../helpers/axios'

export const state = {
    campaign: null,
    campaigns: []
};

export const getters = {
    campaign: (state) => state.campaign,
    campaigns: (state) => state.campaigns,
};

export const mutations = {
    setCampaign(state, newValue) {
        state.campaign = newValue;
    },
    setCampaigns(state, newValue) {
        state.campaign = newValue;
    },
};

export const actions = {
    createCampaign(_, data) {
        return new Promise((resolve, reject) => {
            api.post("/campaigns", data).then((res) => {
                if (res) {
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },

    updateCampaign(_, {id, data}) {
        return new Promise((resolve, reject) => {
            api.put("/campaigns/" + id, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },


    deleteCampaign(_, id) {
        return new Promise((resolve) => {
            api.delete("/campaigns/" + id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchCampaign({commit}, {campaign}) {
        return new Promise((resolve, reject) => {
            api.get("/campaigns/" + campaign).then((res) => {
                commit("setCampaign", res.data.data);
                resolve(res.data.data)
            }).catch(err => {
                reject(err)
            })
        });
    },
    /*
        fetchCampaigns({commit}, {site, name, position, field, isActive, page, limit, listType}) {
            let query = "?";

            if (listType) {
                query += `listType=${listType}&`;
            } else {
                query += `page=${page}&`;
                query += `limit=${limit}&`;
            }

            if (site) {
                query += `site=${site}&`;
            }
            if (name) {
                query += `name=${name}&`;
            }
            if (position) {
                query += `position=${position}&`;
            }
            if (field) {
                query += `field=${field}&`;
            }

            if (isActive !== undefined) {
                query += `isActive=${isActive}&`;
            }

            return new Promise((resolve) => {
                api.get("/sites" + query).then((res) => {
                    commit("setCampaigns", res.data.data);
                    resolve(res.data.data);
                });
            });
        },*/


    fetchCampaigns({commit}, {site, name, position, field, isActive, page, limit, listType}) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

        if (site) {
            query += `site=${site}&`;
        }
        if (name) {
            query += `name=${name}&`;
        }
        if (position) {
            query += `position=${position}&`;
        }
        if (field) {
            query += `field=${field}&`;
        }

        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }

        return new Promise((resolve) => {
            api.get("/campaigns" + query).then((res) => {
                commit("setCampaigns", res.data.data);
                resolve(res.data.data);
            });
        });
    },

};
